import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section, SectionHeading } from './Shared';
export interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
  product?: string;
}
export const TestimonialCard = ({
  initials,
  name,
  location,
  text,
  product
}: TestimonialProps) => <figure className="glass-panel gold-frame p-6 md:p-8 rounded-sm flex flex-col h-full" data-id="element-239" data-mp="3azt41l3w4rhw">
    <div className="flex items-center mb-5" data-id="element-240" data-mp="3700up66oahbh">
      <div className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-brand-surfaceLight flex items-center justify-center text-brand-goldDark font-display font-bold text-base md:text-lg border border-brand-gold/40 mr-4 shrink-0" data-id="element-241" data-mp="36wmpzrajdw0v">
        {initials}
      </div>
      <figcaption data-id="element-242" data-mp="2s309zmmwfmmi">
        <div className="flex text-brand-gold mb-1" aria-label="5 de 5 estrellas" data-id="element-243" data-mp="2s3jhsaiu4umt">
          {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 fill-current" data-id="element-244" data-mp="v72ftgnn6uin" data-mpi={i} />)}
        </div>
        <div className="font-medium text-brand-purpleDark" data-id="element-245" data-mp="q8iwlo0fnwtz">{name}</div>
        <div className="text-xs text-brand-muted" data-id="element-246" data-mp="h4deiq6avw6a">
          {location} {product && `— ${product}`}
        </div>
      </figcaption>
    </div>
    <blockquote className="text-brand-text/90 italic flex-grow font-display text-[17px] leading-relaxed" data-id="element-247" data-mp="77s9i4ua6l2g">
      “{text}”
    </blockquote>
  </figure>;
export const InitialTestimonials = () => <Section className="pb-16" data-id="element-248" data-mp="zwfwq5ylbkin">
    <div className="max-w-3xl mx-auto" data-id="element-249" data-mp="zw66qidjpdcy">
      <TestimonialCard initials="MG" name="María G." location="Madrid" text="Por primera vez tengo un sistema completo para planificar mis sesiones de Chi Kung con criterio clínico real. Mis pacientes notan la diferencia desde la primera semana." data-id="element-250" data-mp="zx7r5dggbc7c" />
    </div>
  </Section>;
const testimonials: TestimonialProps[] = [{
  initials: 'MG',
  name: 'María G.',
  location: 'Madrid',
  product: 'Terapeuta holística',
  text: 'Por primera vez tengo un sistema para planificar mis sesiones con criterio clínico real. El vademécum de series por patología ha cambiado por completo mi forma de trabajar.'
}, {
  initials: 'JL',
  name: 'Julián L.',
  location: 'Barcelona',
  product: 'Chi Kung terapéutico',
  text: 'El Tomo I de protección del terapeuta me salvó del agotamiento crónico. Antes terminaba cada jornada sin energía. Hoy tengo protocolos reales y mi rendimiento es completamente distinto.'
}, {
  initials: 'SM',
  name: 'Sofía M.',
  location: 'Valencia',
  product: 'Terapeuta en formación',
  text: 'Acababa de empezar y el Mega Pack me dio la estructura que necesitaba desde el primer paciente. Los 52 guiones de visualización por sí solos justifican todo el pack.'
}, {
  initials: 'DL',
  name: 'Diego L.',
  location: 'Sevilla',
  product: 'Terapeuta holístico',
  text: 'El protocolo de Chi Kung adaptado me abrió un nicho que no imaginaba. Hoy trabajo con personas mayores y pacientes posquirúrgicos con total seguridad clínica.'
}];
export const MoreTestimonials = () => <Section className="pb-16" data-id="element-251" data-mp="32ge0gxlc6vuh">
    <SectionHeading eyebrow="Testimonios" className="mb-12" data-id="element-252" data-mp="32j9x8ilg7ehc">
      Lo que dicen los terapeutas que ya lo tienen
    </SectionHeading>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-253" data-mp="3cettj63xcf6m">
      {testimonials.map(t => <TestimonialCard key={t.name} {...t} data-id="element-254" data-mp="3gfnim2t3s013" />)}
    </div>
  </Section>;